enum P {
  YouHave = 1,
  Selected = 2,
  SelectLanguage = 3,
  YouHaveSelectedLanguage = 4,
  TerminalsAreNamedAfter = 5,
  CityAndNumberedConsecutively = 6,
  SelectBookCompartment = 7,
  BlindVisualyImparedShould = 8,
  SelectBarrierFree = 9,
  BookCompartment = 10,
  BarrierFreeBooking = 11,
  SelectCompartmentSize = 12,
  DoYouNeedUnder13 = 13,
  Yes = 14,
  No = 15,
  YesINeed = 16,
  NoIDontNeed = 17,
  DoYouWantToBook = 18,
  CompartmentSize = 19,
  Hours = 20,
  Hours2 = 21,
  StartTime = 22,
  ChangeStartTime = 23,
  For = 24,
  HoursAtThePrice = 25,
  Book = 26,
  GTCRead = 27,
  GTCOpen = 28,
  PleaseAcceptGTC = 29,
  YesIAccept = 30,
  CancelBooking = 31,
  PleaseEnterEmail = 32,
  AftrSuccessfullyCreatingReserervation = 33,
  EmailWithCode = 34,
  AfterPlacingParcelYouReceive = 35,
  EmailWithPickUpCode = 36,
  YourEmailAddress = 37,
  Confirm = 38,
  BookingSuccessfullyCompleted = 39,
  YouWillReceiveEmail = 40,
  AddressYouSupplied = 41,
  EmailContainsPickUpCode = 42,
  AnExplanationOfUsage = 43,
  HoursAtThePrice2 = 44,
  CalenderTime = 45,
  YouHaveCancelledTheBooking = 46,
  PleaseEnterYourEmail = 47
}

enum Lang {
  DE = 0,
  EN = 1,
  SK = 2
}

function getLang(lang: number): Lang {
    if(lang === 0) {
        return Lang.DE;
    } else if(lang === 1) {
        return Lang.EN;
    } else if(lang === 2) {
        return Lang.SK
    } else {
        return Lang.EN;
    }
}

function gT(phrase: P, langValue: number): string {
    let lang: Lang = getLang(langValue);
    let returnPhrase = "NO_TRANSLATION";
    console.log('phrase: ' + phrase + ', lV: ' + langValue + ', l: ' + lang)
    switch(phrase) {
        case P.YouHave:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Sie haben das Schließfach-Terminal mit dem Namen:";
                    break;
                case Lang.SK:
                    returnPhrase = "Ahoj, som Tamburi box: ";
                    break;
            }
            break;
        case P.Selected:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = " gewählt";
                    break;
                case Lang.SK:
                    returnPhrase = "";
                    break;
            }
            break;
        case P.SelectLanguage:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "bitte wählen Sie Ihre Sprache.";
                    break;
                case Lang.SK:
                    returnPhrase = "V akom jazyku chceš pokračovať?";
                    break;
            }
            break;
        case P.YouHaveSelectedLanguage:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Sie haben die Sprache Deutsch gewählt.";
                    break;
                case Lang.EN:
                    returnPhrase = "You have selected English as your language.";
                    break;
                case Lang.SK:
                    returnPhrase = "Vybral si si slovenčinu.";
                    break;
            }
            break;
        case P.TerminalsAreNamedAfter:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Alle unsere Schließfach-Terminals sind nach Sehenswürdigkeiten in der jeweiligen";
                    break;
                case Lang.EN:
                    returnPhrase = "All of our locker terminals are named after landmarks in the respective";
                    break;
                case Lang.SK:
                    returnPhrase = "Teraz si vyber konkrétny box a urob rezerváciu.";
                    break;
            }
            break;
        case P.CityAndNumberedConsecutively:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Stadt benannt und durchnummeriert. Wie hier: Terminal ";
                    break;
                case Lang.EN:
                    returnPhrase = "city and numbered consecutively. For example: Terminal ";
                    break;
                case Lang.SK:
                    returnPhrase = "";
                    break;
            }
            break;
        case P.SelectBookCompartment:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Wählen Sie den Button “Fach buchen” um ein Gepäckstück einzulegen.";
                    break;
                case Lang.EN:
                    returnPhrase = "Select the “Book compartment” button to reserve a locker.";
                    break;
                case Lang.SK:
                    returnPhrase = "";
                    break;
            }
            break;
        case P.BlindVisualyImparedShould:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Blinde und sehbehinderte Personen wählen zum Buchen";
                    break;
                case Lang.EN:
                    returnPhrase = "Blind and visually impaired individuals should";
                    break;
                case Lang.SK:
                    returnPhrase = "";
                    break;
            }
            break;
        case P.SelectBarrierFree:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "eines Faches den Button “barrierefreies Buchen”.";
                    break;
                case Lang.EN:
                    returnPhrase = "select the “Barrier-free booking” button to reserve a locker.";
                    break;
                case Lang.SK:
                    returnPhrase = "";
                    break;
            }
            break;
        case P.BookCompartment:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Fach buchen";
                    break;
                case Lang.EN:
                    returnPhrase = "Book compartment";
                    break;
                case Lang.SK:
                    returnPhrase = "Rezervuj si box";
                    break;
            }
            break;
        case P.BarrierFreeBooking:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Barrierefreies buchen";
                    break;
                case Lang.EN:
                    returnPhrase = "Barrier-free booking";
                    break;
                case Lang.SK:
                    returnPhrase = "Bezbariérová rezervácia";
                    break;
            }
            break;
        case P.SelectCompartmentSize:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Bitte wählen Sie die gewünschte Fachgröße.";
                    break;
                case Lang.EN:
                    returnPhrase = "Select compartment size.";
                    break;
                case Lang.SK:
                    returnPhrase = "Vyber si veľkosť boxu.";
                    break;
            }
            break;
        case P.DoYouNeedUnder13:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Benötigen Sie ein Schließfach unter 1,3 Meter Höhe?";
                    break;
                case Lang.EN:
                    returnPhrase = "Do you need a compartment under 1,3 meters?";
                    break;
                case Lang.SK:
                    returnPhrase = "Potrebuješ box do výšky 1,3 metra?";
                    break;
            }
            break;
        case P.Yes:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Ja";
                    break;
                case Lang.EN:
                    returnPhrase = "Yes";
                    break;
                case Lang.SK:
                    returnPhrase = "Áno";
                    break;
            }
            break;
        case P.No:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Nein";
                    break;
                case Lang.EN:
                    returnPhrase = "No";
                    break;
                case Lang.SK:
                    returnPhrase = "Nie";
                    break;
            }
            break;
        case P.YesINeed:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Ja, ich benötige ein Fach unter 1,3 Meter Höhe";
                    break;
                case Lang.EN:
                    returnPhrase = "Yes, I need a compartment under 1,3 meters";
                    break;
                case Lang.SK:
                    returnPhrase = "Áno";
                    break;
            }
            break;
        case P.NoIDontNeed:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Nein, ich benötige kein Fach unter 1,3 Meter Höhe";
                    break;
                case Lang.EN:
                    returnPhrase = "No, I don't need a compartment under 1,3 meters";
                    break;
                case Lang.SK:
                    returnPhrase = "Nie";
                    break;
            }
            break;
        case P.DoYouWantToBook:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Sie wollen ein Fach mit der Größe";
                    break;
                case Lang.EN:
                    returnPhrase = "Do you want to book compartment with size";
                    break;
                case Lang.SK:
                    returnPhrase = "Zhrniem ti tvoj výber: box";
                    break;
            }
            break;
        case P.CompartmentSize:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Fachgröße";
                    break;
                case Lang.EN:
                    returnPhrase = "Compartment size";
                    break;
                case Lang.SK:
                    returnPhrase = "Veľkosť boxu";
                    break;
            }
            break;
        case P.Hours:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Stunden";
                    break;
                case Lang.EN:
                    returnPhrase = "Hours";
                    break;
                case Lang.SK:
                    returnPhrase = "hodiny";
                    break;
            }
            break;
        case P.Hours2:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Stunden";
                    break;
                case Lang.EN:
                    returnPhrase = "Hours";
                    break;
                case Lang.SK:
                    returnPhrase = "hodín";
                    break;
            }
            break;
        case P.StartTime:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Startzeit";
                    break;
                case Lang.EN:
                    returnPhrase = "Start-time";
                    break;
                case Lang.SK:
                    returnPhrase = "Začiatok rezervácie";
                    break;
            }
            break;
        case P.ChangeStartTime:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Startzeit ändern";
                    break;
                case Lang.EN:
                    returnPhrase = "Change Start-time";
                    break;
                case Lang.SK:
                    returnPhrase = "Nastav si iný začiatok rezervácie.";
                    break;
            }
            break;
        case P.For:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "für";
                    break;
                case Lang.EN:
                    returnPhrase = "for";
                    break;
                case Lang.SK:
                    returnPhrase = "na";
                    break;
            }
            break;
        case P.HoursAtThePrice:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Stunden um";
                    break;
                case Lang.EN:
                    returnPhrase = "Hours at the price of";
                    break;
                case Lang.SK:
                    returnPhrase = "hodiny za cenu";
                    break;
            }
            break;
        case P.HoursAtThePrice2:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Stunden um";
                    break;
                case Lang.EN:
                    returnPhrase = "Hours at the price of";
                    break;
                case Lang.SK:
                    returnPhrase = "hodín za cenu";
                    break;
            }
            break;
        case P.Book:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = " buchen?";
                    break;
                case Lang.EN:
                    returnPhrase = "?";
                    break;
                case Lang.SK:
                    returnPhrase = "?";
                    break;
            }
            break;
        case P.GTCRead:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "AGB gelesen";
                    break;
                case Lang.EN:
                    returnPhrase = "GT&C read";
                    break;
                case Lang.SK:
                    returnPhrase = "Súhlasím s Obchodnými podmienkami (VOP)";
                    break;
            }
            break;
        case P.GTCOpen:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "AGB öffnen";
                    break;
                case Lang.EN:
                    returnPhrase = "Show GT&C";
                    break;
                case Lang.SK:
                    returnPhrase = "(VOP)";
                    break;
            }
            break;
        case P.PleaseAcceptGTC:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Bitte akzeptieren Sie unsere AGB um fortzufahren.";
                    break;
                case Lang.EN:
                    returnPhrase = "Please accept our Terms and Conditions to continue.";
                    break;
                case Lang.SK:
                    returnPhrase = "Pre pokračovanie potvrď súhlas.";
                    break;
            }
            break;
        case P.YesIAccept:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Ja, ich akzeptiere die AGBs";
                    break;
                case Lang.EN:
                    returnPhrase = "Yes, I accept GT&C";
                    break;
                case Lang.SK:
                    returnPhrase = "Pre pokračovanie potvrď súhlas.";
                    break;
            }
            break;
        case P.CancelBooking:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Buchungsvorgang abbrechen";
                    break;
                case Lang.EN:
                    returnPhrase = "Cancel booking";
                    break;
                case Lang.SK:
                    returnPhrase = "Nie";
                    break;
            }
            break;
        case P.PleaseEnterEmail:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Geben Sie unten im Eingabefeld Ihre E-Mail-Adresse ein.";
                    break;
                case Lang.EN:
                    returnPhrase = "Please enter your email in textfield below";
                    break;
                case Lang.SK:
                    returnPhrase = "Zadaj svoj e-mail nižšie.";
                    break;
            }
            break;
        case P.AftrSuccessfullyCreatingReserervation:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Nach erfolgreicher Erstellung der Reservierung erhalten Sie";
                    break;
                case Lang.EN:
                    returnPhrase = "After successfully creating a reservation you will receive";
                    break;
                case Lang.SK:
                    returnPhrase = "Po úspešnom vytvorení rezervácie ti pošlem";
                    break;
            }
            break;
        case P.EmailWithCode:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Ihren Einlagecode auf diese E-Mail-Adresse.";
                    break;
                case Lang.EN:
                    returnPhrase = "an E-mail with code to put in the parcel";
                    break;
                case Lang.SK:
                    returnPhrase = "e-mail s kódom na vloženie zásielky.";
                    break;
            }
            break;
        case P.AfterPlacingParcelYouReceive:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Nach Einlage Ihres Gepäckstückes erhalten Sie";
                    break;
                case Lang.EN:
                    returnPhrase = "After placing your parcel you will receive";
                    break;
                case Lang.SK:
                    returnPhrase = "Následne, po vložení zásielky ti príde druhý";
                    break;
            }
            break;
        case P.EmailWithPickUpCode:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "auch Ihren Abholcode auf diese E-Mail-Adresse.";
                    break;
                case Lang.EN:
                    returnPhrase = "an E-mail with picku-up code";
                    break;
                case Lang.SK:
                    returnPhrase = "e-mail s kódom na vyzdvihnutie zásielky.";
                    break;
            }
            break;
        case P.YourEmailAddress:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Ihre E-Mail Adresse";
                    break;
                case Lang.EN:
                    returnPhrase = "Your Email Addres";
                    break;
                case Lang.SK:
                    returnPhrase = "Tvoj e-mail";
                    break;
            }
            break;
        case P.Confirm:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Bestätigen";
                    break;
                case Lang.EN:
                    returnPhrase = "Confirm";
                    break;
                case Lang.SK:
                    returnPhrase = "Potvrď";
                    break;
            }
            break;
        case P.BookingSuccessfullyCompleted:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Buchung erfolgreich abgeschlossen!";
                    break;
                case Lang.EN:
                    returnPhrase = "Booking successfully completed!";
                    break;
                case Lang.SK:
                    returnPhrase = "Rezervácia prebehla úspešne.";
                    break;
            }
            break;
        case P.YouWillReceiveEmail:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Sie erhalten in Kürze eine E-Mail an die von Ihnen angegebene";
                    break;
                case Lang.EN:
                    returnPhrase = "Shortly you will receive an email on the";
                    break;
                case Lang.SK:
                    returnPhrase = "O chvíľu obdržíš e-mail kódom na vloženie";
                    break;
            }
            break;
        case P.AddressYouSupplied:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "E-Mail Adresse.";
                    break;
                case Lang.EN:
                    returnPhrase = "address that you have supplied";
                    break;
                case Lang.SK:
                    returnPhrase = "zásielky s informáciami o ďalšom postupe.";
                    break;
            }
            break;
        case P.EmailContainsPickUpCode:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Diese E-Mail beinhaltet Ihren Einlagecode sowie";
                    break;
                case Lang.EN:
                    returnPhrase = "This email will contain pick-up code as well as";
                    break;
                case Lang.SK:
                    returnPhrase = "";
                    break;
            }
            break;
        case P.AnExplanationOfUsage:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "eine Erklärung zur Bedienung.";
                    break;
                case Lang.EN:
                    returnPhrase = "an explanation of the usage.";
                    break;
                case Lang.SK:
                    returnPhrase = "";
                    break;
            }
            break;
        case P.CalenderTime:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Zeit";
                    break;
                case Lang.EN:
                    returnPhrase = "Time";
                    break;
                case Lang.SK:
                    returnPhrase = "Čas";
                    break;
            }
            break;
        case P.YouHaveCancelledTheBooking:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Du hast den Vorgang abgebrochen.";
                    break;
                case Lang.EN:
                    returnPhrase = "You have cancelled the booking.";
                    break;
                case Lang.SK:
                    returnPhrase = "Rezerváciu si zrušil(a).";
                    break;
            }
            break;
        case P.PleaseEnterYourEmail:
            switch(lang) {
                case Lang.DE:
                    returnPhrase = "Bitte geben Sie eine E-Mail-Adresse ein";
                    break;
                case Lang.EN:
                    returnPhrase = "Please, enter your E-mail address";
                    break;
                case Lang.SK:
                    returnPhrase = "Prosím, zadaj tvoj e-mail.";
                    break;
            }
            break;

    }
    return returnPhrase;
}

export const tS = {
  gT,
  P,
  Lang
};